import { TYPES } from '../../common/constants';

export const setSuiteFormData = payload => ({
  type: TYPES.SET_SUITE_FORM_DATA,
  payload,
});
export const clearSuiteFormData = () => ({
  type:TYPES.CLEAR_SUITE_FORM_DATA,
 })